var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPopulationDensity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2679_1180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1763 0.73877H10.8237C4.84595 0.73877 0 5.58472 0 11.5625V47.915C0 53.8928 4.84595 58.7388 10.8237 58.7388H47.1763C53.154 58.7388 58 53.8928 58 47.915V11.5625C58 5.58472 53.154 0.73877 47.1763 0.73877Z",
    fill: "#B9EB73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5291 27.525C43.7802 27.525 45.6051 25.7001 45.6051 23.449C45.6051 21.1979 43.7802 19.373 41.5291 19.373C39.278 19.373 37.4531 21.1979 37.4531 23.449C37.4531 25.7001 39.278 27.525 41.5291 27.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4777 29.7202H38.5774C36.2133 29.7202 34.2969 31.6367 34.2969 34.0008V34.0008C34.2969 36.3648 36.2133 38.2813 38.5774 38.2813H44.4777C46.8418 38.2813 48.7583 36.3648 48.7583 34.0008C48.7583 31.6367 46.8418 29.7202 44.4777 29.7202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1014 27.525C19.3525 27.525 21.1773 25.7001 21.1773 23.449C21.1773 21.1979 19.3525 19.373 17.1014 19.373C14.8503 19.373 13.0254 21.1979 13.0254 23.449C13.0254 25.7001 14.8503 27.525 17.1014 27.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0519 29.7202H14.1516C11.7876 29.7202 9.87109 31.6367 9.87109 34.0008V34.0008C9.87109 36.3648 11.7876 38.2813 14.1516 38.2813H20.0519C22.416 38.2813 24.3325 36.3648 24.3325 34.0008C24.3325 31.6367 22.416 29.7202 20.0519 29.7202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2469 39.9894C21.9951 39.9894 19.3496 37.3439 19.3496 34.0921C19.3496 30.8403 21.9951 28.1948 25.2469 28.1948H32.5045C35.7563 28.1948 38.4018 30.8403 38.4018 34.0921C38.4018 37.3439 35.7563 39.9894 32.5045 39.9894H25.2469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5043 28.8268C35.4122 28.8268 37.7695 31.1841 37.7695 34.092C37.7695 36.9999 35.4122 39.3572 32.5043 39.3572H25.2467C22.3388 39.3572 19.9815 36.9999 19.9815 34.092C19.9815 31.1841 22.3388 28.8268 25.2467 28.8268H32.5043ZM33.0794 26.5278H24.6716C20.5007 26.5278 17.1074 29.9211 17.1074 34.092C17.1074 38.2629 20.5007 41.6562 24.6716 41.6562H33.0794C37.2503 41.6562 40.6436 38.2629 40.6436 34.092C40.6436 29.9211 37.2503 26.5278 33.0794 26.5278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8749 26.5565C31.6439 26.5565 33.8885 24.3118 33.8885 21.5429C33.8885 18.774 31.6439 16.5293 28.8749 16.5293C26.106 16.5293 23.8613 18.774 23.8613 21.5429C23.8613 24.3118 26.106 26.5565 28.8749 26.5565Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2679_1180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(0 0.73877)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopulationDensity);
export default __webpack_public_path__ + "static/media/population-density.47bc8a7ac8c8d4fb0fbe927ba3407282.svg";
export { ForwardRef as ReactComponent };